import React from "react";
import { Route } from "react-router-dom";
import { 
    CaseDetailsDrawer,
    CaseMetaInfo,
    CaseTaskNotes
} from "templates";

export default class CaseDetailsWrapper extends React.Component {
    // components = {};
    // componentDidMount() {
    //     this.loadComponents();
    // }
    // async loadComponents() {
    //     this.components = await Promise.all([
    //         import(
    //             /* webpackChunkName: "templates/CaseDetailsDrawer" */
    //             /* webpackMode: "lazy" */
    //             /* webpackExports: ["default", "named"] */
    //             "../templates/case-details-tabs").then(_ => {
    //             return { ["CaseDetailsDrawer"]: _.default };
    //         }),
    //         import(
    //             /* webpackChunkName: "templates/CaseTaskNotes" */
    //             /* webpackMode: "lazy" */
    //             /* webpackExports: ["default", "named"] */ 
    //             "../templates/case-task-notes").then(_ => {
    //             return { ["CaseTaskNotes"]: _.default };
    //         }),
    //         import(
    //             /* webpackChunkName: "templates/CaseMetaInfo" */
    //             /* webpackMode: "lazy" */
    //             /* webpackExports: ["default", "named"] */ 
    //             "../templates/case-meta-info").then(_ => {
    //             return { ["CaseMetaInfo"]: _.default };
    //         })
    //     ]).then(_ => 
    //         _.reduce((cur, agg) => ({...agg, ...cur}), {})
    //     );
    // }
    render() {
        const { props } = this;
        // if(Object.keys(this.components).length === 0) {
        //     return null;
        // }
        return (
            <CaseDetailsDrawer {...props}>
                <Route
                    path={"/app/:pageID"}
                    render={(props) => <CaseTaskNotes {...props} />}
                />
                <Route
                    path={"/app/:pageID"}
                    render={(props) => <CaseMetaInfo {...props} />}
                />
            </CaseDetailsDrawer>
        );
    }
}
